import Ajax from '../ajax';

export default {
  media: (data) => Ajax('get', 'media/info', data),
  mediaList: () => Ajax('get', 'media/list'),
  delete: (mediaId) => Ajax('post', `media/delete/${mediaId}`),
  add: (data) => Ajax('post', 'media/add', data),
  edit: (data) => Ajax('post', 'media/edit', data),
};
